if (!window.Eurus.loadedScript.has('product-catalog-table.js')) {
  window.Eurus.loadedScript.add('product-catalog-table.js');

  const initProductCatalogTable = (root) => {
    if (!root || root.dataset.pctBound === 'true') return;
    root.dataset.pctBound = 'true';

    const quantityMap = {};
    const DEFAULT_QTY = 1;

    const getDefaultQty = (maxQty) => (maxQty > 0 ? DEFAULT_QTY : 0);

    const getProductItem = (el) => el.closest('.pct-desktop-row, .pct-mobile-card');

    const getOptionValue = (variant, position) => {
      if (position === 1) return variant.option1 || '';
      if (position === 2) return variant.option2 || '';
      if (position === 3) return variant.option3 || '';
      return '';
    };

    const getVariantsData = (item) => {
      const jsonEl = item.querySelector('[data-pct-variants-json]');
      if (!jsonEl) return [];
      try {
        return JSON.parse(jsonEl.textContent);
      } catch {
        return [];
      }
    };

    const getMengeSelect = (item) => item.querySelector('[data-pct-option-select="menge"]');
    const getDarreichungSelect = (item) => item.querySelector('[data-pct-option-select="darreichung"]');

    const getOptionPositions = (item) => ({
      menge: parseInt(item.dataset.pctOptionMengePosition, 10) || 0,
      darreichung: parseInt(item.dataset.pctOptionDarreichungPosition, 10) || 0,
    });

    const findVariant = (item, mengeValue, darreichungValue) => {
      const variants = getVariantsData(item);
      const { menge, darreichung } = getOptionPositions(item);
      const mengeSelect = getMengeSelect(item);
      const darreichungSelect = getDarreichungSelect(item);

      return variants.find((variant) => {
        const matchesMenge =
          !mengeSelect || !menge || getOptionValue(variant, menge) === mengeValue;
        const matchesDarreichung =
          !darreichungSelect || !darreichung || getOptionValue(variant, darreichung) === darreichungValue;
        return matchesMenge && matchesDarreichung;
      });
    };

    const rebuildDarreichungOptions = (item, mengeValue, preserveSelection = true) => {
      const darreichungSelect = getDarreichungSelect(item);
      if (!darreichungSelect) return;

      const variants = getVariantsData(item);
      const { menge, darreichung } = getOptionPositions(item);
      if (!darreichung) return;

      const previous = preserveSelection ? darreichungSelect.value : '';
      const values = new Set();

      variants.forEach((variant) => {
        if (menge && getOptionValue(variant, menge) !== mengeValue) return;
        const value = getOptionValue(variant, darreichung);
        if (value && value !== 'Default Title') values.add(value);
      });

      darreichungSelect.innerHTML = '';
      Array.from(values).forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        darreichungSelect.appendChild(option);
      });

      if (previous && values.has(previous)) {
        darreichungSelect.value = previous;
      }
    };

    const resetQuantity = (item, variantId, maxQty, previousVariantId) => {
      if (previousVariantId && previousVariantId !== variantId) {
        delete quantityMap[previousVariantId];
      }

      if (quantityMap[variantId] === undefined) {
        quantityMap[variantId] = getDefaultQty(maxQty);
      }

      item.querySelectorAll('[data-pct-quantity]').forEach((wrapper) => {
        wrapper.setAttribute('data-variant-id', variantId);
        wrapper.setAttribute('data-max', maxQty);
        const valueEl = wrapper.querySelector('[data-quantity-value]');
        const minusBtn = wrapper.querySelector('[data-action="decrease"]');
        const plusBtn = wrapper.querySelector('[data-action="increase"]');
        const qty = quantityMap[variantId] ?? getDefaultQty(maxQty);

        if (valueEl) {
          valueEl.setAttribute('data-quantity-value', variantId);
          valueEl.setAttribute('data-max', maxQty);
          valueEl.textContent = String(qty);
        }

        [minusBtn, plusBtn].forEach((btn) => {
          if (!btn) return;
          btn.setAttribute('data-key', variantId);
        });

        if (minusBtn) minusBtn.disabled = qty <= 0;
        if (plusBtn) plusBtn.disabled = qty >= maxQty || maxQty === 0;
      });
    };

    const syncVariantToItem = (item, variant) => {
      if (!item || !variant) return;

      const previousBuyKey = item.querySelector('[data-pct-buy]')?.getAttribute('data-key');
      const variantId = String(variant.id);
      const maxQty = parseInt(variant.max, 10) || 0;

      item.querySelectorAll('[data-pct-field="sku"]').forEach((el) => {
        el.textContent = variant.sku || '';
      });
      item.querySelectorAll('[data-pct-field="price"]').forEach((el) => {
        el.textContent = variant.price_formatted || '';
      });

      item.querySelectorAll('[data-pct-buy]').forEach((btn) => {
        btn.setAttribute('data-key', variantId);
        btn.disabled = !variant.available;
        btn.classList.toggle('is-disabled', !variant.available);
      });

      item.querySelectorAll('[data-pct-wishlist]').forEach((btn) => {
        btn.setAttribute('data-variant-id', variantId);
      });

      resetQuantity(item, variantId, maxQty, previousBuyKey);
    };

    const resolveAndSync = (item) => {
      const mengeSelect = getMengeSelect(item);
      const darreichungSelect = getDarreichungSelect(item);
      const variants = getVariantsData(item);

      if (!mengeSelect && !darreichungSelect) {
        if (variants[0]) syncVariantToItem(item, variants[0]);
        return;
      }

      const mengeValue = mengeSelect?.value || '';
      const darreichungValue = darreichungSelect?.value || '';
      const variant = findVariant(item, mengeValue, darreichungValue);

      if (variant) {
        syncVariantToItem(item, variant);
        return;
      }

      item.querySelectorAll('[data-pct-buy]').forEach((btn) => {
        btn.disabled = true;
        btn.classList.add('is-disabled');
      });
    };

    const initItemVariantState = (item) => {
      const mengeSelect = getMengeSelect(item);
      if (mengeSelect) {
        rebuildDarreichungOptions(item, mengeSelect.value, true);
      }
      resolveAndSync(item);
    };

    const initQuantities = () => {
      root.querySelectorAll('[data-pct-quantity]').forEach((wrapper) => {
        const variantId = wrapper.getAttribute('data-variant-id');
        if (!variantId) return;
        const valueEl = wrapper.querySelector('[data-quantity-value]');
        const maxQty = parseInt(wrapper.getAttribute('data-max'), 10) || 0;
        const qty = parseInt(valueEl?.textContent, 10);
        quantityMap[variantId] = Number.isNaN(qty) ? getDefaultQty(maxQty) : qty;

        const minusBtn = wrapper.querySelector('[data-action="decrease"]');
        const plusBtn = wrapper.querySelector('[data-action="increase"]');
        const resolvedQty = quantityMap[variantId];
        if (minusBtn) minusBtn.disabled = resolvedQty <= 0;
        if (plusBtn) plusBtn.disabled = resolvedQty >= maxQty || maxQty === 0;
      });
    };

    const handleQuantityChange = (button) => {
      const action = button.getAttribute('data-action');
      const key = button.getAttribute('data-key');
      if (!action || !key) return;

      const wrapper = button.closest('[data-pct-quantity]');
      const valueEl = wrapper?.querySelector('[data-quantity-value]');
      if (!valueEl) return;

      let maxQuantity = parseInt(valueEl.getAttribute('data-max'), 10);
      if (isNaN(maxQuantity)) maxQuantity = 9999;

      let currentValue = quantityMap[key] ?? parseInt(valueEl.textContent, 10) ?? 0;

      if (action === 'increase' && currentValue < maxQuantity && maxQuantity > 0) {
        currentValue += 1;
      } else if (action === 'decrease' && currentValue > 0) {
        currentValue -= 1;
      }

      quantityMap[key] = currentValue;
      valueEl.textContent = currentValue;

      const minusBtn = wrapper.querySelector('[data-action="decrease"]');
      const plusBtn = wrapper.querySelector('[data-action="increase"]');
      if (minusBtn) minusBtn.disabled = currentValue <= 0;
      if (plusBtn) plusBtn.disabled = currentValue >= maxQuantity;
    };

    const addItemToCart = async (variantId, quantity) => {
      if (quantity < 1) return;

      if (!window.Alpine?.store('xCartHelper')) {
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        return;
      }

      await Alpine.store('xCartHelper').waitForCartUpdate();
      window.updatingCart = true;

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity }],
          sections: Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id),
        }),
      });

      const data = await response.json();
      window.updatingCart = false;

      if (data.status === 422) {
        console.error(data.description || 'Could not add to cart');
        return;
      }

      Alpine.store('xCartHelper').reRenderSections(data.sections);
      if (Alpine.store('xQuickView')?.show) Alpine.store('xQuickView').show = false;
      Alpine.store('xPopup')?.close();

      if (Alpine.store('xCartNoti')?.enable) {
        Alpine.store('xCartNoti').setItem(data);
      } else {
        Alpine.store('xMiniCart').openCart();
        document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
      }

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.innerHTML, 10);
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    };

    const getVariantSelectWrap = (select) => select?.closest('.pct-variant-select-wrap');

    const setVariantSelectOpen = (select, isOpen) => {
      const wrap = getVariantSelectWrap(select);
      if (!wrap) return;
      wrap.classList.toggle('is-open', isOpen);
    };

    root.addEventListener('mousedown', (event) => {
      const optionSelect = event.target.closest('[data-pct-option-select]');
      if (!optionSelect) return;

      if (document.activeElement === optionSelect) {
        setVariantSelectOpen(optionSelect, false);
      } else {
        setVariantSelectOpen(optionSelect, true);
      }
    });

    root.addEventListener(
      'blur',
      (event) => {
        if (!event.target.matches('[data-pct-option-select]')) return;
        setVariantSelectOpen(event.target, false);
      },
      true
    );

    root.addEventListener('change', (event) => {
      const optionSelect = event.target.closest('[data-pct-option-select]');
      if (!optionSelect) return;

      const item = getProductItem(optionSelect);
      if (!item) return;

      if (optionSelect.dataset.pctOptionSelect === 'menge') {
        rebuildDarreichungOptions(item, optionSelect.value, false);
      }

      resolveAndSync(item);
      setVariantSelectOpen(optionSelect, false);
      optionSelect.blur();
    });

    root.addEventListener('click', (event) => {
      const header = event.target.closest('.pct-mobile-card__header');
      if (header) {
        const card = header.closest('.pct-mobile-card');
        const body = card?.querySelector('.pct-mobile-card__body');
        if (!card || !body) return;
        const isOpen = card.classList.toggle('is-open');
        header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        body.hidden = !isOpen;
        return;
      }

      const qtyButton = event.target.closest('.pct-quantity-selector__button');
      if (qtyButton) {
        handleQuantityChange(qtyButton);
        return;
      }

      const buyBtn = event.target.closest('[data-pct-buy]');
      if (buyBtn) {
        if (buyBtn.disabled || buyBtn.classList.contains('is-disabled')) return;
        const variantId = buyBtn.getAttribute('data-key');
        if (!variantId) return;
        const maxQty = parseInt(
          buyBtn.closest('.pct-desktop-row, .pct-mobile-card')?.querySelector('[data-pct-quantity]')?.getAttribute('data-max'),
          10
        ) || 0;
        const quantity = quantityMap[variantId] ?? getDefaultQty(maxQty);
        if (quantity < 1) return;
        buyBtn.disabled = true;
        addItemToCart(variantId, quantity).finally(() => {
          buyBtn.disabled = buyBtn.classList.contains('is-disabled');
        });
        return;
      }
    });

    root.querySelectorAll('.pct-desktop-row, .pct-mobile-card').forEach(initItemVariantState);
    initQuantities();
  };

  window.initProductCatalogTable = initProductCatalogTable;

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-catalog-table]').forEach((root) => {
      initProductCatalogTable(root);
    });
  });
}
